import React, { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { SmileyHappy, SmileyNeutral, SmileyNotHappy } from '../icons'


export function Feedback() {
const [state, setState] = useState(null)
const style1 = state === 1 ? { boxShadow: '', backgroundColor: 'rgba(0,200,0,0.1)', padding:'1rem'} : { boxShadow: '3px 5px 6px rgba(0,0,0,0.5)', padding:'1rem'}
const style2 = state === 2 ? { boxShadow: '', backgroundColor: 'rgba(250,200,100,0.1)', padding:'1rem'} : { boxShadow: '3px 5px 6px rgba(0,0,0,0.5)', padding:'1rem'}
const style3 = state === 3 ? { boxShadow: '', backgroundColor: 'rgba(250,0,0,0.1)', padding:'1rem'} : { boxShadow: '3px 5px 6px rgba(0,0,0,0.5)', padding:'1rem'}
	
return (
	<Container fluid style={{'maxWidth': '1100px'}}>
	
	<Row style={{'marginTop': '4rem'}}>
	<Col />
	<Col xs='auto' >
	<div style={style1} onClick={() => setState(1)}>
	<SmileyHappy />
	</div>
	</Col>
	<Col />
	</Row>
	
	<Row style={{'marginTop': '4rem'}}>
	<Col />
	<Col xs='auto' >
	<div style={style2} onClick={() => setState(2)}>
	<SmileyNeutral />
	</div>
	</Col>
	<Col />
	</Row>
	
	<Row style={{'marginTop': '4rem'}}>
	<Col />
	<Col xs='auto' >
	<div style={style3} onClick={() => setState(3)}>
	<SmileyNotHappy />
	</div>
	</Col>
	<Col />
	</Row>

	</Container>
)
}
